import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditMotivosDevolucionComponent } from "./edit-motivos-devolucion/edit-motivos-devolucion.component";

@Component({
  selector: "app-motivos-devolucion",
  templateUrl: "./motivos-devolucion.component.html",
  styleUrls: ["./motivos-devolucion.component.scss"],
})
export class MotivosDevolucionComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditMotivosDevolucionComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
